import React from "react";
import moment from "moment";

import { getText } from "../../../../../helpers";
import { checkPendingTranslation } from "../../../../../helpers/checkPendingTranslation";
import ControlTranslationIdLabel from "../../../../../components/control_translation_id_label";
import { TranslationLibraryControlDetails } from "../translation_library_control_details";

const TAGS_OPTIONS = [
  { label: "AI translation", value: "ai_translation" },
  { label: "Manual Translation", value: "manual_translation" },
  { label: "Approved", value: "approved" },
];

export default function TranslationsCellFormatter(props) {
  const { control, language, isTranslation, openNewTranslation, showTranslationModal, pendingTranslations } = props;
  const _language = language.value.toLowerCase();
  const { isPendingTranslation, isFailedTranslation } = checkPendingTranslation(control, pendingTranslations, _language);
  const translation = control["translations"] && control["translations"][_language];
  const translation_result = translation && translation.translation_result;

  if (translation_result) {
    translation_result.id = control.id;
    translation_result.custom_id = control.custom_id;
  }
  const controlDetails = isTranslation ? translation_result : control;

  return isTranslation ? (
    <div className="translation-table-formatter">
      <div className="content">
        {isPendingTranslation && (
          <div className="pending-translation">
            {getText("Translating")} <div className="ui active inline loader"></div>
          </div>
        )}
        {isFailedTranslation && (
          <div className="failed-translation">
            {getText('Translation failed. Try again by clicking "New Translation"')}
          </div>
        )}
        <div className="id-and-tags">
          <ControlTranslationIdLabel translation={translation} onClick={() => showTranslationModal(translation_result.translation_id)} />
          {translation && translation.tag_list &&
            <span className="translation-tags">
              {translation.tag_list.map((tag) => {
                const option = TAGS_OPTIONS.find(({ value }) => value === tag);

                return (
                  <span className="translation-tag" key={tag}>
                    {option.label}
                  </span>
                );
              })}
            </span>
          }
        </div>
        <TranslationLibraryControlDetails control={controlDetails} />
      </div>
      <div className="translation-actions">
        {!isFailedTranslation && translation_result && (
          <span className="link text-light-blue" onClick={() => openNewTranslation("manual")}>
            {getText("Edit Translation")}
          </span>
        )}
        <span className="link text-light-blue" onClick={() => openNewTranslation("ai")}>
          {getText("New Translation")}
        </span>
      </div>
    </div>
  ) : (
    <div className="translation-table-formatter">
      <div className="content">
        <TranslationLibraryControlDetails control={controlDetails} />
        {control.archived && <div className="archived archived-label">{getText("Archived")} ({moment(control.archive_date).format("DD-MMM-YYYY")})</div>}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/control_library/table/tanslations_modal/translation_modal_content/tanslations_table_formatter.js